// carousel
//import { smartmenus } from "smartmenus/dist/jquery.smartmenus";
import "smartmenus/dist/css/sm-core-css.css";

jQuery('#main-menu').smartmenus();